import axios from '../../axios'

// ** Function to get all sports
const getAllSports = async (params) => {
  const res = await axios.get(
    `/sport/all?search=${params.search}&limit=${params.limit}&sort=${params.sort}&page=${params.page}`,
  )
  return res?.data
}

export { getAllSports }
